import {service, baseURL} from '@/utils/request'
//import axios from 'axios';

export function _http(url, data, method = 'POST') {
	return service({
		url,
		method,
		data
	})
}

// export function _download(url, data, method='POST'){
// 	return axios.get(
// 		url, 
// 		params: {},
		
// 	)
// }

export const errorMessage = (msg, that) => {
	const summary = that && that.$t ? that.$t('eventRecords.messages.requestError') : 'Request Error';
	that.$toast.add({ severity: 'error', summary, detail: msg, life: 2000 });
}

export const hostUrl = baseURL;
